import CornerRadius from "../../api/model/snapshots/layers/CornerRadius";

function equals(cornerRadius: CornerRadius, otherCornerRadius: CornerRadius) {
    return (
        cornerRadius.topLeft === otherCornerRadius.topLeft &&
        cornerRadius.topRight === otherCornerRadius.topRight &&
        cornerRadius.bottomRight === otherCornerRadius.bottomRight &&
        cornerRadius.bottomLeft === otherCornerRadius.bottomLeft
    );
}

export { equals };
